import React from "react";
import { useLocation } from "react-router-dom";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import TwoColSingleFeatureWithStats2 from "components/features/TwoColSingleFeatureWithStats2.js";
import SimpleContactUs from "components/forms/SimpleContactUs.js";
import Footer from "components/footers/MiniCenteredFooter.js";
const Details = () => {
  const location = useLocation();
  return (
    <AnimationRevealPage>
      <TwoColSingleFeatureWithStats2 data={location.state} />
      <SimpleContactUs />
      <Footer />
    </AnimationRevealPage>
  );
};

export default Details;
